module.exports = __webpack_public_path__ + "img/pma560_terminals_banana_plugs.f01ef17e.jpg";